import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { CardEmptyState } from 'components/atoms/empty-state';
import { Loading } from 'components/atoms/loading';

export const LoadingContent: FC = () => {
  return (
    <CardEmptyState
      message={
        <>
          <p>
            <Loading size="large" />
          </p>
          <p>
            <FormattedMessage id="loading" />
          </p>
        </>
      }
    />
  );
};
